// CopyLinkBox.js
'use strict';
import { connect } from 'react-redux';

import CopyLinkBox from '../component/CopyLinkBox.jsx';

import copyTextWithToastr from '../action/copyTextWithToastr.js';

import getOperationData from '../selector/getOperationData.js';
import getShortLinkData from '../selector/getShortLinkData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';

import { ShareType } from '../hook/useShortShareLink.js';
import { breakpoint } from '../style/variables.js';
import {
  ANDROID_MINIMUM_VERSION,
  SWAG_ANDROID_PACKAGE_NAME,
} from '../RemoteConfigKeys.js';
import getShareLink from '../resource/getShareLink.js';

const mapStateToProps = (state, { shareType }) => {
  const swagAndroidPackageName = getRemoteConfigData(
    state,
    SWAG_ANDROID_PACKAGE_NAME
  );
  const androidMinimunVersion = getRemoteConfigData(
    state,
    ANDROID_MINIMUM_VERSION
  );
  const shareLink =
    shareType === ShareType.LIVESTREAM
      ? getShareLink({
          query: {
            link: typeof window !== 'undefined' ? window?.location?.href : null,
            afl: typeof window !== 'undefined' ? window?.location?.href : null,
            apn: swagAndroidPackageName,
            amv: androidMinimunVersion,
          },
        })
      : getShareLink();
  const deviceWidth = getOperationData(state, ['device'], 'width');

  return {
    shortLink: getShortLinkData(state, shareLink),
    isOnMobile: deviceWidth <= breakpoint.mobile,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    copyTextWithToastr: data => dispatch(copyTextWithToastr(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CopyLinkBox);
